import React from 'react';
import { connect, useSelector } from 'react-redux';

// @TODO Replace me with a container equivalent
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';

import { Container } from '@zillow/zrs-comet';

import BillingActions from 'app/shared/actions/BillingActions';

import { INVOICE_PAYMENTS } from 'app/shared/constants/RouteConstants';

import PermissionCheck from 'app/shared/components/PermissionCheck';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import BillingPaymentMethods from 'app/shared/components/Billing/BillingPaymentMethods';
import Breadcrumb from 'app/shared/components/Breadcrumb';
import { withErrorBoundary } from 'app/shared/components/ErrorBoundary';
import {
    FormField,
    Text,
    Label,
    Spacer,
} from '@zillow/constellation';

import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

const propTypes = {};

const PAGE_TITLE = 'Edit Auto Pay Settings';

// Stylesheets
import '../InvoicePage/style.scss';
import { StyledAccountSettingsContainer } from './StyledComponents';

const InvoicePage = ({
    dispatch,
    match,
}) => {
    const accountName = useSelector(state => state.billing.accountPaymentMethods.accountName);

    const handleSubmit = (selectedCreditCardId, autopayEnabled) => {
        if (autopayEnabled) {
            return dispatch(BillingActions.saveDefaultPaymentMethod({
                accountNumber: match.params.accountNumber,
                defaultPaymentMethodId: selectedCreditCardId,
                autopayEnabled,
            })).catch(() => {
                // Todo handle error
            });
        }
        return dispatch(BillingActions.removeAutopay({
            accountNumber: match.params.accountNumber,
        })).catch(() => {
            // Todo handle error
        });
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={INVOICE_PAYMENTS}>
                <div className="InvoicePage">
                    <HeadWrapper title={PAGE_TITLE} />
                    <Container>
                        <Breadcrumb title="Back" redirectTo="/rental-manager/billing/paymentSettings" />
                        <StyledAccountSettingsContainer borderFull={true} borderRounded={true}>
                            <Spacer padding="sm">
                                <Container style={{ padding: 0 }}>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <Text fontType="h4">
                                                {PAGE_TITLE}
                                            </Text>
                                            <Spacer paddingBottom="lg" />
                                            <FormField>
                                                <Label>
                                                    ACCOUNT:
                                                </Label>
                                                {accountName}
                                            </FormField>
                                            <Spacer paddingBottom="md" />
                                            <BillingPaymentMethods
                                                accountNumber={match.params.accountNumber}
                                                onSubmit={handleSubmit}
                                                allowRemove={true}
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                            </Spacer>
                        </StyledAccountSettingsContainer>
                    </Container>
                </div>
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

InvoicePage.propTypes = propTypes;

export { InvoicePage };
export default withErrorBoundary(connect()(InvoicePage));
